import { Box, styled } from '@mui/material';

const Scale = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: 14,
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  overflow: 'hidden',
}));

export default Scale;